"use strict";
/**
 * Shared response DTOs reused across more than one Clinical endpoint
 * contract — mirrors each entity's real Prisma shape
 * (`prisma/schema.prisma`, frozen since Stage 6C.1) as returned by the
 * certified Repository/Domain/Application Service layers, hand-
 * declared here since this package does not import backend/Prisma
 * source (`CLINICAL-CONTRACT-REUSE.md` §6, mirroring
 * `financial-common.response.ts`'s own established discipline). Dates
 * are ISO strings, UUIDs are strings. No money-shaped fields exist in
 * Clinical — no integer-paise convention applies here.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLINICAL_APPROVAL_CHAIN_STEP_RESPONSE_EXAMPLE = exports.CLINICAL_WORKFLOW_TIMELINE_ENTRY_RESPONSE_EXAMPLE = exports.AUDIT_LOG_RESPONSE_EXAMPLE = exports.CLINICAL_TIMELINE_ENTRY_RESPONSE_EXAMPLE = exports.CLINICAL_ORDER_RESPONSE_EXAMPLE = exports.CLINICAL_DOCUMENT_VERSION_RESPONSE_EXAMPLE = exports.CLINICAL_DOCUMENT_RESPONSE_EXAMPLE = exports.ENCOUNTER_RESPONSE_EXAMPLE = void 0;
exports.ENCOUNTER_RESPONSE_EXAMPLE = {
    id: '55555555-5555-5555-5555-555555555555',
    tenantId: '22222222-2222-2222-2222-222222222222',
    patientId: '11111111-1111-1111-1111-111111111111',
    visitId: '22222222-2222-2222-2222-222222222222',
    departmentId: '33333333-3333-3333-3333-333333333333',
    providerId: '44444444-4444-4444-4444-444444444444',
    encounterTypeId: null,
    startedAt: '2026-07-17T09:00:00.000Z',
    endedAt: null,
    completedAt: null,
    status: 'IN_PROGRESS',
    lockVersion: 2,
    priorityTier: 0,
    clinicalStateId: null,
    closureReasonCodeId: null,
    closureReasonDescription: null,
    createdAt: '2026-07-17T09:00:00.000Z',
    updatedAt: '2026-07-17T09:05:00.000Z',
};
exports.CLINICAL_DOCUMENT_RESPONSE_EXAMPLE = {
    id: '88888888-8888-8888-8888-888888888888',
    tenantId: '22222222-2222-2222-2222-222222222222',
    patientId: '11111111-1111-1111-1111-111111111111',
    encounterId: '55555555-5555-5555-5555-555555555555',
    documentType: 'SOAP',
    templateId: null,
    structuredContent: null,
    freeTextContent: 'Patient reports mild headache, no fever.',
    originatingOrderId: null,
    amendsDocumentId: null,
    ipAdmissionId: null,
    status: 'DRAFT',
    lockVersion: 1,
    authoredBy: '77777777-7777-7777-7777-777777777777',
    signedAt: null,
    signedBy: null,
    coSignedAt: null,
    coSignedBy: null,
    contentHash: null,
    createdAt: '2026-07-17T09:10:00.000Z',
    updatedAt: '2026-07-17T09:10:00.000Z',
};
exports.CLINICAL_DOCUMENT_VERSION_RESPONSE_EXAMPLE = {
    id: 'dddddddd-dddd-dddd-dddd-dddddddddddd',
    tenantId: '22222222-2222-2222-2222-222222222222',
    documentId: '88888888-8888-8888-8888-888888888888',
    versionNumber: 1,
    structuredContentSnapshot: null,
    freeTextContentSnapshot: 'Patient reports mild headache, no fever.',
    recordedAt: '2026-07-17T09:10:00.000Z',
    recordedBy: '77777777-7777-7777-7777-777777777777',
};
exports.CLINICAL_ORDER_RESPONSE_EXAMPLE = {
    id: 'cccccccc-cccc-cccc-cccc-cccccccccccc',
    tenantId: '22222222-2222-2222-2222-222222222222',
    patientId: '11111111-1111-1111-1111-111111111111',
    encounterId: '55555555-5555-5555-5555-555555555555',
    orderType: 'LAB',
    testMasterId: 'bbbbbbbb-bbbb-bbbb-bbbb-bbbbbbbbbbbb',
    radiologyProcedureMasterId: null,
    drugMasterId: null,
    procedureMasterId: null,
    priorityTier: 0,
    orderDetail: null,
    status: 'TRANSMITTED',
    lockVersion: 2,
    orderingProviderId: '77777777-7777-7777-7777-777777777777',
    signedAt: '2026-07-17T09:15:00.000Z',
    signedBy: '77777777-7777-7777-7777-777777777777',
    cancelledAt: null,
    cancelledBy: null,
    cancellationReason: null,
    createdAt: '2026-07-17T09:12:00.000Z',
    updatedAt: '2026-07-17T09:15:00.000Z',
};
exports.CLINICAL_TIMELINE_ENTRY_RESPONSE_EXAMPLE = {
    type: 'DOCUMENT',
    id: '88888888-8888-8888-8888-888888888888',
    occurredAt: '2026-07-17T09:10:00.000Z',
    title: 'Discharge summary',
    detail: 'Finalised',
};
exports.AUDIT_LOG_RESPONSE_EXAMPLE = {
    id: 'eeeeeeee-eeee-eeee-eeee-eeeeeeeeeeee',
    tenantId: '22222222-2222-2222-2222-222222222222',
    userId: '77777777-7777-7777-7777-777777777777',
    action: 'CLINICAL_DOCUMENT_CREATED',
    entityType: 'ClinicalDocument',
    entityId: '88888888-8888-8888-8888-888888888888',
    before: null,
    after: { status: 'DRAFT' },
    reason: null,
    occurredAt: '2026-07-17T09:10:00.000Z',
};
exports.CLINICAL_WORKFLOW_TIMELINE_ENTRY_RESPONSE_EXAMPLE = {
    ...exports.CLINICAL_TIMELINE_ENTRY_RESPONSE_EXAMPLE,
    auditTrail: [exports.AUDIT_LOG_RESPONSE_EXAMPLE],
};
exports.CLINICAL_APPROVAL_CHAIN_STEP_RESPONSE_EXAMPLE = {
    sequence: 1,
    roleId: 'aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa',
    isMandatory: true,
};
//# sourceMappingURL=clinical-common.response.js.map